<template>
  <div>
    <!-- <DynamicNavDrawer
      :drawerOpen="signUpDrawerOpen"
      @drawerClosed="drawerClosed"
      :type="'signup'"
    >
      <template v-slot:content>
        <DrawerSignUp
          @loginClicked="loginClicked"
          :isActivationLink="isActivationLink"
          :isReferralLink="isReferralLink"
          :isPasswordResetLink="isPasswordResetLink"
          :verifyUserLinkCode="verifyUserLinkCode"
          :contentOpen="signUpDrawerOpen"
        />
      </template>
    </DynamicNavDrawer> -->
    <!-- <DynamicNavDrawer
      :drawerOpen="signInDrawerOpen"
      @drawerClosed="signInDrawerClosed"
      :type="'signin'"
    >
      <template v-slot:content>
        <DrawerSignIn
          @signupClicked="signupClicked"
          :drawerOpen="signInDrawerOpen"
          @successResetPassword="successResetPassword"
        />
      </template>
    </DynamicNavDrawer> -->

    <Layout :containers="containers">
      <template v-slot:header>
        <HomeHeroBar
          :hasQuickStartCallout="false"
          @quickStartCardLinkClicked="quickStartCardLinkClicked"
          @gradientButtonClicked="buttonAction"
          :carouselCycle="false"
        />
      </template>

      <template v-slot:info-tiles>
        <div class="section-padding">
          <InfoTilesContainer :tiles="infoTiles" />
        </div>
      </template>
      <template v-slot:create-your-will>
        <CreateYourWillBanner @createYourWill="createYourWill" />
      </template>
    </Layout>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
  </div>
</template>

<script>
  import HomeHeroBar from './HomeHeroBar.vue';
  import ButtonTilesContainer from '../ButtonTilesContainer.vue';
  import InfoTilesContainer from '../InfoTilesContainer.vue';
  import CreateYourWillBanner from '../CreateYourWillBanner.vue';
  import ImageTextBanner from '../ImageTextBanner.vue';
  import TestimonialsSection from '../TestimonialsSection.vue';
  import HR from '../../common/HR.vue';
  import Layout from '../../common/layouts/Layout.vue';
  import DynamicNavDrawer from '../../guest/DynamicNavDrawer.vue';
  import DrawerSignUp from '../../guest/DrawerSignUp.vue';
  import DrawerSignIn from '../../guest/DrawerSignIn.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';

  export default {
    name: 'LandingSimple',

    metaInfo() {
      return {
        meta: this.whitelabel.developmentMeta,
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.homepage,
          },
        ],
      };
    },
    props: {
      openSignupDrawerImmediately: {
        required: false,
        default: false,
        type: Boolean,
      },
      isReferralLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isActivationLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isPasswordResetLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      verifyUserLinkCode: {
        required: false,
        default: null,
        type: Object,
      },
    },
    components: {
      HomeHeroBar,
      ButtonTilesContainer,
      InfoTilesContainer,
      CreateYourWillBanner,
      ImageTextBanner,
      TestimonialsSection,
      DynamicNavDrawer,
      HR,
      Layout,
      DrawerSignUp,
      DrawerSignIn,
      SuccessSnackbar,
    },
    data(props) {
      return {
        signUpDrawerOpen: props.openSignupDrawerImmediately,
        signInDrawerOpen: false,
        showAlert: false,
        alertMessage: null,
        countryPattern: require('@/assets/shared/redesign/backgrounds/country-pattern.svg'),
        greenAccentOne: require('@/assets/shared/redesign/backgrounds/green-accent-1.svg'),
        greenAccentTwo: require('@/assets/shared/redesign/backgrounds/green-accent-2.svg'),
        purpleAccent: require('@/assets/shared/redesign/backgrounds/purple-accent.svg'),
        tribalPattern: require(`@/assets/old_mutual/homepage/generic.svg`),
        delayedOpenSignup: false,
      };
    },
    mounted() {
      this.setLandingLocalStorage();
      this.$nextTick(() => {
        setTimeout(() => {
          this.signUpDrawerOpen = true;
        }, 1000);
      });
    },
    methods: {
      successResetPassword() {
        this.signInDrawerOpen = false;
        this.alertMessage =
          this.whitelabel.authentication.resetPassword.successMessage;
        this.showAlert = true;
      },
      loginClicked() {
        this.signUpDrawerOpen = false;
        this.signInDrawerOpen = true;
      },
      signupClicked() {
        this.signInDrawerOpen = false;
        this.signUpDrawerOpen = true;
      },
      drawerClosed() {
        this.signUpDrawerOpen = false;
      },
      signInDrawerClosed() {
        this.signInDrawerOpen = false;
      },
      quickStartCardLinkClicked(routeName) {
        if (routeName === 'SignUpPage') {
          this.signUpDrawerOpen = true;
        } else {
          this.$router.push({ name: routeName });
        }
      },
      createYourWill() {
        this.signUpDrawerOpen = true;
      },
      estateCostCalculator() {
        this.$router.push({
          name: 'EstateAdministrationCostCalculator',
        });
      },
      buttonAction(action) {
        if (action === 'SignUp') {
          this.signUpDrawerOpen = true;
        }
      },
      setLandingLocalStorage() {
        localStorage.setItem('isLandingSimple', true);
      },
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          { name: 'info-tiles', background: 'countryPattern', fadedRow: true },
          {
            name: 'create-your-will',
            class: 'section-margin',
          },
        ];
      },
      buttonTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.homeButtonTileOne,
            title: 'A straightforward process ',
            description: `Planning for the future can be overwhelming. Our guided, expert-backed  process makes it easy, ensuring your final wishes are securely recorded for peace of mind.`,
          },
          {
            imageUrl: this.whitelabel.images.homeButtonTileTwo,
            title: 'Customised estate protection',
            description: `When you pass, your loved ones will face estate administration costs. EstateAssist offers cover for estate costs, education and cash flow needs, and debt protection.`,
          },
          {
            imageUrl: this.whitelabel.images.homeButtonTileThree,
            title: 'Easy updates',
            description: `Life changes, and your will should too. Log in, update your will, and finalise the new version. It’s quick, simple, and keeps your will aligned with your wishes.`,
          },
        ];
      },
      infoTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.homeInfoTitleOne,
            title: 'Trusted expertise',
            description:
              'A step-by-step process, built by professionals with expert support every step of the way.',
          },
          {
            imageUrl: this.whitelabel.images.homeInfoTitleTwo,
            title: 'Accessibility',
            description:
              'Create your will anytime, anywhere, without discussing personal details with a stranger.',
          },
          {
            imageUrl: this.whitelabel.images.homeInfoTitleThree,
            title: 'Straightforward process',
            description:
              'Expert-designed steps make creating your will easier than you think.',
          },
          {
            imageUrl: this.whitelabel.images.homeInfoTitleFour,
            title: 'Comprehensive solutions',
            description:
              'From planning to protection, secure your legacy with our estate services.',
          },
        ];
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media only screen and (min-width: 601px) and (max-width: 807px) {
    .mobile-padding-top {
      padding-top: 111px;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 600px) {
    .mobile-padding-top {
      padding-top: 133px;
    }
  }
</style>
